import React from "react";

const sizeOptions = [
  { value: "xxxl", label: "XXXL" },
  { value: "xxl", label: "XXL" },
  { value: "xl", label: "XL" },
  { value: "l", label: "L" },
  { value: "m", label: "M" },
  { value: "s", label: "S" },
  { value: "xs", label: "XS" },
];

const levelOptions = [
  { label: "", value: "" },
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
];

const HeadingBlock = {
  label: "Heading",
  fields: {
    text: { type: "textarea", contentEditable: true },
    size: { type: "select", options: sizeOptions },
    level: { type: "select", options: levelOptions },
    align: {
      type: "radio",
      options: [
        { label: "Left", value: "left" },
        { label: "Center", value: "center" },
        { label: "Right", value: "right" },
      ],
    },
  },
  defaultProps: {
    text: "Heading",
    size: "m",
    level: "",
    align: "left",
  },
  render: ({ text, size, level, align }) => {
    const Tag = level ? `h${level}` : "div";

    const sizeMap = {
      xxxl: "text-6xl",
      xxl: "text-5xl",
      xl: "text-4xl",
      l: "text-3xl",
      m: "text-2xl",
      s: "text-xl",
      xs: "text-lg",
    };

    return (
      <Tag style={{ textAlign: align }} className={sizeMap[size] || ""}>
        {text}
      </Tag>
    );
  },
};

export default HeadingBlock;
